import ApiError from "@components/GenericApiError/Error";
import Grid from "@components/Grid/Grid";
import { logoutUser } from "@utilities/navigation";
import { useRouter } from "next/router";
import { useState } from "react";
import IconCross from "../../public/image/svg/cross.svg";
import styles from "./C70_ConfirmChangeEmail.module.scss";

export interface C70_ConfirmChangeEmailProps {
  title: string;
  introText: string;
  proceedText: string;
  cancelText: string;
  changeEmailRedirectPage?: {
    fields?: {
      slug?: string;
    };
  };
}

export const C70_ConfirmChangeEmail = (props: {
  content: C70_ConfirmChangeEmailProps;
}) => {
  const { content } = props;
  const { title, introText, proceedText, cancelText } = content;

  const [error] = useState<boolean>(false);
  const router = useRouter();

  const handleProceed = () => {
    const slug = content.changeEmailRedirectPage?.fields?.slug;
    const loginWithRedirect = `.netlify/functions/login?returnUrl=/${slug}`;
    logoutUser(encodeURIComponent(loginWithRedirect));
  };

  const handleCancel = () => {
    router.push("/my-profile");
  };

  if (error) {
    return <ApiError />;
  }

  return (
    <div className="wrapper">
      <Grid column md={12} sm={12}>
        <div className={styles["confirm-change-email"]}>
          <h1>{title}</h1>

          <p className={styles["intro-text"]}>{introText}</p>

          <div className={styles["button-wrapper"]}>
            <input
              type="submit"
              id="ProceedButton"
              value={proceedText}
              className={`cta primary ${styles["proceed-button"]}`}
              onClick={handleProceed}
            />

            <button
              type="button"
              id="CancelButton"
              className={styles["cancel-button"]}
              onClick={handleCancel}
            >
              <span className={styles["icon-cross"]}>
                <IconCross />
              </span>
              <span>{cancelText}</span>
            </button>
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default C70_ConfirmChangeEmail;
